/* eslint-disable @typescript-eslint/no-explicit-any */
// UIMessage.ts
import { message } from "antd";
import WarningIcon from "../../assets/icons/warning-icon.svg";
import ButtonField from "./Button";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Fragment, ReactNode } from "react";

interface UIMessageParams {
  messageText: ReactNode;
  btnText?: string;
  onClose?: () => void;
  closeIcon?: boolean;
  autoClose?: boolean;
  onNavigate?: () => void;
  isClose?: boolean;
  closeText?: string;
}

let overlayElement: HTMLDivElement | null = null;
let overlayRoot: any = null;

const createOverlay = () => {
  if (overlayElement) return;

  overlayElement = document.createElement("div");
  overlayElement.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 999;
    pointer-events: auto;
  `;

  document.body.appendChild(overlayElement);
  document.body.style.overflow = "hidden";
};

const removeOverlay = () => {
  if (overlayElement) {
    document.body.removeChild(overlayElement);
    overlayElement = null;
    document.body.style.overflow = "";
  }
  if (overlayRoot) {
    overlayRoot.unmount();
    overlayRoot = null;
  }
};

export function UIMessage({
  messageText,
  onClose,
  btnText,
  closeIcon,
  autoClose,
  onNavigate,
  isClose,
  closeText
}: UIMessageParams) {
  const key = "custom-ui-message"; // for controlling the same instance

  const handleClose = () => {
    message.destroy(key);
    removeOverlay();
    setTimeout(() => {
      onClose?.();
    }, 200);
    // onClose && onClose();
    // message.destroy(key);
    // removeOverlay();
  };

  const content = (
    <Fragment>
      {closeIcon && <CloseCircleOutlined onClick={handleClose} />}
      {autoClose &&
        (() => {
          setTimeout(() => {
            message.destroy(key);
            removeOverlay();
          }, 13000);
          return null;
        })()}
      <div className="prompt-content">
        <img src={WarningIcon} alt="Warning" />
        <span>{messageText}</span>
      </div>
      <div className="btn-container">
        {isClose ? (
          <Fragment>
            <ButtonField
              text={closeText || "Close"}
              type={"default"}
              onClick={handleClose}
              className="m-t-10 m-r-10"
            />
            <ButtonField
              text={btnText || "Okay"}
              type={"primary"}
              onClick={() => {
                handleClose();
                if (onNavigate) onNavigate();
              }}
              className="m-t-10"
            />
          </Fragment>
        ) : (
          <ButtonField
            text={btnText || "Okay"}
            type={"primary"}
            onClick={handleClose}
            className="m-t-10"
          />
        )}
      </div>
    </Fragment>
  );
  createOverlay();

  message.config({
    duration: 0,
    maxCount: 1,
  });

  message.open({
    key,
    content,
    className: "grn-prompt-message",
    style: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      position: "fixed",
      zIndex: 1000,
    },
    duration: 0,
    onClose: removeOverlay,
  });
}
